<template>
  <div id="loading-container">
    <div class="loading" :class="{ 'nodisplay' : true }"><i
      class='fas fa-circle-notch fa-spin fa-5x'></i></div>
    <pageheader/>
    <b-container fluid>
      <div class="body-width">
        <b-row>
          <b-col>
            <summarygraph/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <summarylist/>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>


<script>
import pageheader from '../../pageheader.vue'
import summarygraph from './summarygraph/summarygraph.vue'
import summarylist from './summarylist/summarylist.vue'

export default {
  name: 'summary-graph',

  components: {
    pageheader,
    summarygraph,
    summarylist,
  },

  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../../unit.scss" lang="scss"></style>



// WEBPACK FOOTER //
// summary.vue?15aba6cf